import { makeConstantFactory } from 'utils/constantsHelper'
const makeConstant = makeConstantFactory('externalApp')

export const FETCH_OAUTH_CODE = makeConstant('FETCH_OAUTH_CODE')
export const FETCH_OAUTH_CODE_SUCCESS = makeConstant('FETCH_OAUTH_CODE_SUCCESS')
export const FETCH_OAUTH_CODE_FAILED = makeConstant('FETCH_OAUTH_CODE_FAILED')
export const FETCH_OAUTH_CODE_PENDING = makeConstant('FETCH_OAUTH_CODE_PENDING')

export const FETCH_OAUTH_APP_INFO = makeConstant('FETCH_OAUTH_APP_INFO')
export const FETCH_OAUTH_APP_INFO_SUCCESS = makeConstant('FETCH_OAUTH_APP_INFO_SUCCESS')
export const FETCH_OAUTH_APP_INFO_FAILED = makeConstant('FETCH_OAUTH_APP_INFO_FAILED')
export const FETCH_OAUTH_APP_INFO_PENDING = makeConstant('FETCH_OAUTH_APP_INFO_PENDING')


// WEBPACK FOOTER //
// ./src/scripts/app/modules/externalApp/constants.js